import { cabangmodul_get_list_outlet_reducers } from "../reducers/cabangReducers";

const modulCabang = {
  cabangmodul_get_list_outlet: cabangmodul_get_list_outlet_reducers,
};

export default modulCabang;
